<template>
  <div class="topup-form">
    <div class="topup-form-frame">
      <div>
        <h1>{{ $t('view.history.header') }}</h1>
        <history-filter />
        <history-pagination />
        <history-list />
        <history-pagination />
      </div>
    </div>
  </div>
</template>

<script>
import HistoryFilter from '@/plus/components/History/Filter'
import HistoryList from '@/plus/components/History/List'
import HistoryMixin from '@/common/mixins/views/History.mixin'
import HistoryPagination from '@/plus/components/History/Pagination'

export default {
  name: 'History',
  mixins: [HistoryMixin],
  components: {
    HistoryPagination,
    HistoryList,
    HistoryFilter
  }
}
</script>

<style src="../assets/scss/history.scss" lang="scss"></style>
